import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import UserContext from "../../../context/UserContext";

/**
 * ProtectedRoute component that wraps routes requiring authentication
 * @param {ReactNode} children - The component to render if authenticated
 * @param {string|string[]} requiredRole - The role(s) required to access this route (e.g., 'EMPLOYEE', 'ADMIN', or ['EMPLOYEE', 'ADMIN'])
 * @param {string} redirectTo - The path to redirect to if not authenticated
 */
const ProtectedRoute = ({ children, requiredRole, redirectTo }) => {
  const { user } = useContext(UserContext);

  // Check if user is authenticated with the required role(s)
  const allowedRoles = Array.isArray(requiredRole)
    ? requiredRole
    : [requiredRole];
  const isAuthenticated = user && allowedRoles.includes(user.role);

  if (!isAuthenticated) {
    // Redirect to the appropriate login page
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default ProtectedRoute;
